module.exports = __webpack_public_path__ + "img/api-step-3@2x.0ef283b3.png";